/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import dtm from 'scripts/services/dtm';
import stringUtil from 'scripts/utils/string';
import miniLeaderBoardTableView from './mini-leader-board-table.stache';
import _ from 'lodash';

const updateInterval = 45 * 1000;

export const MiniLeaderBoard = BaseControl.extend({
    init: function () {
        this._super();

        this.$container = $('.js-mini-leader-board-container');
        this.getData();
        setInterval(this.getData.bind(this), updateInterval);
    },

    getData() {
        can.ajax({
            type: 'GET',
            url: this.options.url,
            headers: {
                'Content-Type': 'application/json'
            },
            success: this.parseData.bind(this)
        });
    },

    getPlayerName(name, isShort = false) {
        const fullName = name.trim().replace('(a)', '').split(',').reverse().map(name => name.trim());
        const isAmateur = name.indexOf('(a)') > -1;

        return (isShort ? stringUtil.makeShortPlayerName(fullName.join(' ')) :
            `${fullName[0]} ${fullName.slice(1).join(' ')}`) + `${isAmateur ? ' (a)' : ''}`;
    },

    parseData(data) {
        if (!data) {
            return;
        }

        const root = _.get(data, 'event.tournament', data);
        const type = _.get(root, 'display.phase', 'strokeplay');
        const isCup = /walkercup|curtiscup/.test(this.options.url);
        let title = 'Leaders';
        let footerText = 'Full Leader Board';
        let headerText = isCup ? _.get(root, 'matchplay.matches.round', 'Match status') : 'Match status';

        let rows = [];

        switch (type) {
            case 'matchplay': {
                title = 'Scoring';
                footerText = 'Full Scoring';
                const matches = _.get(root, 'matchplay.matches.match', []);
                rows = (_.isArray(matches) ? matches : [matches]).map((match) => {
                    const playerOne = _.get(match, 'playerOne', _.get(match, 'team1')) || '';
                    const playerTwo = _.get(match, 'playerTwo', _.get(match, 'team2')) || '';
                    const playerOnePos = null;
                    const playerTwoPos = null;
                    const isPlayerOneLeader = parseInt(match.leader, 10) === 1;
                    const standing = _.get(match, 'standing', '');

                    return {
                        playerOne,
                        playerOnePos,
                        isPlayerOneLeader,
                        isNotHalved: standing.toLowerCase() !== 'halved' && match.leader,
                        isCompleted: match.status === 'completed',
                        playerTwo,
                        playerTwoPos,
                        standing
                    }
                });
                break;
            }
            case 'strokeplay': {
                const players = _.get(root, 'players.player', _.get(root, 'strokeplay.teams.team', _.get(root, 'strokeplay.players.player', [])));
                rows = players
                    .map((player) => {
                        const playerShortName = player.name ? this.getPlayerName(player.name, true) : player.team;
                        const playerFullName = player.name ? this.getPlayerName(player.name, false) : player.team;

                        return {
                            pos: player.position,
                            playerShortName,
                            playerFullName,
                            toPar: player.totaltopar,
                            toParRed: parseInt(player.totaltopar, 10) < 0,
                            thru: player.thru,
                            round: player.today,
                            roundRed: parseInt(player.today, 10) < 0,
                        };
                    });
                break;
            }
        }

        this.$container.html(miniLeaderBoardTableView({
            type,
            rows: rows.slice(0, 5),
            title,
            footerText,
            headerText,
            lbPageUrl: this.options.lbPageUrl,
            leaderboardTitle: this.options.leaderboardTitle
        }));
    },

    '.s-link click': function (el) {
        dtm.trackRightRailLinkToFullClick('MiniLeaderBoard');
    }
});
